import { render } from "./banners.vue?vue&type=template&id=5bf44c13&scoped=true"
import script from "./banners.vue?vue&type=script&lang=js"
export * from "./banners.vue?vue&type=script&lang=js"

import "./banners.vue?vue&type=style&index=0&id=5bf44c13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf44c13"]])

export default __exports__